<template>
  <v-container id="login" fill-height tag="section">
    <v-row justify="center" align="center" class="header-offset">
      <v-slide-y-transition appear>
        <base-material-card light width="100%" max-width="400" class="px-5 py-3" color="primary">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold">
                ALX
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="email"
                name="email"
                type="email"
                label="Email"
                prepend-icon="mdi-email"
              />
              <v-text-field
                v-model="password"
                name="password"
                type="password"
                label="Password"
                prepend-icon="mdi-lock-outline"
                class="mb-8"
              />
              <v-btn :loading="loading" type="submit" name="login" large>
                Login
              </v-btn>
            </v-form>
          </v-card-text>
          <div>v{{ version }}</div>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Toastable from '@/mixins/toastable';
import canDo from '@/utils/permissions';
import { login, tokenLogin } from '@/services/api/authentication_service';
import { version } from '@/../package.json';

export default {
  beforeRouteEnter(to, from, next) {
    const token = to.query['auth-token'];
    if (token) {
      next((vm) => {
        vm.loading = true;
        tokenLogin(token)
          .then(vm.handleLoginSuccess)
          .catch(vm.handleLoginFailure);
      });
    } else {
      next();
    }
  },
  mixins: [Toastable],
  data() {
    return {
      loading: false,
      email: '',
      password: '',
      version,
    };
  },
  computed: {
    ...mapGetters('app', ['activeSite']),
  },
  methods: {
    ...mapActions('app', ['firstTimeLogin']),
    login() {
      this.loading = true;
      login(this.email, this.password)
        .then(this.handleLoginSuccess)
        .catch(this.handleLoginFailure);
    },
    handleLoginSuccess(user) {
      this.successToast(`Welcome ${user['first-name']}!`);
      if (this.activeSite) {
        this.$router.push(`/sites/${this.activeSite}/dashboard`);
      } else {
        this.firstTimeLogin();
      }
      if (canDo('ALXAdminMenu', 'show', true)) {
        this.$router.push('/admin/dashboard');
      }
    },
    handleLoginFailure(error) {
      this.loading = false;
      this.failToast(error);
    },
  },
};
</script>

<style>
/*offset to keep vertically centered including v-card header*/
.header-offset {
  margin-top: -40px;
}
</style>
